import { Button, Tooltip } from "@mui/material";
import { RequestStatus } from "./RequestStatus";
import { TСreateRequestHHDto } from "@src/entities/requestHH/api/requests/createRequestHH";
import { requestHHStore } from "@src/entities/requestHH";
import { useNavigate } from "react-router-dom";

import styles from "./styles.module.scss";
import { truncate } from "@src/shared/lib/truncate";
import { formatSalary, getRequirementTags } from "./utils";

interface IResultProps {
  title_vacancy: string;
  params: TСreateRequestHHDto;
  status: string;
  handleOpenList: () => void;
}

export const ResultTitle = ({
  title_vacancy,
  params,
  status,
  handleOpenList,
}: IResultProps) => {
  const setRequestHHParams = requestHHStore(
    (state) => state.setRequestHHParams,
  );
  const navigate = useNavigate();

  const { salary_from, salary_to, key_skills, requirements } = params;
  const isVisibleSalary = Boolean(salary_from) || Boolean(salary_to);

  const displayTitle = truncate(title_vacancy, 80);
  const isTruncated = title_vacancy.length > 12;

  const handleSettingsBtn = () => {
    if (!params) return;

    setRequestHHParams(params);
    navigate("/change-search-query");
  };

  const salary = formatSalary(salary_from, salary_to);

  const requirementTags = getRequirementTags({
    skills: key_skills,
    requirements,
  })?.slice(0, 4);

  return (
    <div className={styles.resultTitle}>
      <div className={styles.positionTitleWrap}>
        <div className={styles.positionTitleContent}>
          {isTruncated ? (
            <Tooltip title={title_vacancy} arrow>
              <div className={styles.positionTitle}>{displayTitle}</div>
            </Tooltip>
          ) : (
            <div className={styles.positionTitle}>{title_vacancy}</div>
          )}
        </div>

        <div className={styles.positionTitleStatus}>
          <RequestStatus status={status} />
        </div>
      </div>

      {isVisibleSalary && (
        <div className={styles.positionSalary}>
          {salary}
        </div>
      )}

      <div className={styles.positionFooter}>
        <div className={styles.positionKeyWords}>
          {requirementTags?.map((skill, index) => {
            const displayTag =
              skill.length > 15 ? `${skill.substring(0, 15)}...` : skill;

            return (
              <Tooltip title={skill} key={index} arrow>
                <div className={styles.positionKeyWord}>{displayTag}</div>
              </Tooltip>
            );
          })}
        </div>
        <div className={styles.wrapperBtns}>
          <Button className={styles.btn} onClick={handleOpenList}>
            <span>Смотреть всех</span>
          </Button>
          <div className={styles.emptyBlockBtn} />
          <Button className={styles.btn} onClick={handleSettingsBtn}>
            <span>Редактировать</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
